import styled from 'styled-components';

interface ImageProps {
  className?: string;
  src: string;
  alt: string;
  width?: number;
  title?: string;
}

export const ImageNameFormat = styled.div`
  font-weight: bold;
`;

export const Image = (props: ImageProps) => {
  const { className, src, alt, width, title } = props;

  return (
    <div>
      <ImageNameFormat className={className}>{title}</ImageNameFormat>
      <img className={className} src={src} alt={alt} width={`${width}%`} />
    </div>
  );
};
